import React from 'react';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import {FormattedMessage} from 'react-intl';
import MessengerLogo from '../assets/messenger-logo.svg';
import Email from 'material-ui-icons/Email';
import Phone from 'material-ui-icons/Phone';
import Forum from 'material-ui-icons/Forum';
import Schedule from 'material-ui-icons/Schedule';
import {Messenger} from "../utils/enumUtils";
import './supportDialog.css'

class SupportDialog extends React.Component {

   render() {
      const actions = [
         <FlatButton
            label={<FormattedMessage id="general.closeText"/>}
            primary={true}
            onTouchTap={this.props.handleClose}
         />,
      ];

      return (
         <Dialog
            actions={actions}
            modal={false}
            open={this.props.open}
            onRequestClose={this.props.handleClose}
            title={
               <div className="dialogTitleClass">
                  <FormattedMessage id="general.support"/>
               </div>
            }
            contentStyle={{width: "300px", maxWidth: "none"}}
            autoScrollBodyContent={true}
         >
            <div className="row-div">
                <img className="icon" src={MessengerLogo} alt="Messenger Logo" width={Messenger.LOGO.WIDTH} height={Messenger.LOGO.WIDTH}/>
                <a href="https://www.messenger.com/t/vibodj" target="_blank" rel="noopener noreferrer">{<FormattedMessage id="support.messenger"/>}</a>
            </div>
            {/*<div className="row-div">*/}
               {/*<Videocam className="icon"/>*/}
               {/*<a href="https://youtube.com/" target="_blank">{<FormattedMessage id="support.videoLink"/>}</a>*/}
            {/*</div>*/}
            <div className="row-div">
               <Email className="icon"/>
               <a href="mailto:info@vibo.io">{<FormattedMessage id="support.email"/>}</a>
            </div>
            <div className="row-div">
               <Phone className="icon"/>
               <a href="tel:1-917-677-7473">{<FormattedMessage id="support.phone"/>}</a>
            </div>
             <div className="row-div">
                 <Forum className="icon"/>
                 <a href="https://www.facebook.com/groups/viboofficial/" target="_blank" rel="noopener noreferrer">{<FormattedMessage id="support.forum" />}</a>
             </div>
             <div className="row-div">
                 <Schedule className="icon"/>
                 <a href="https://calendly.com/michaelmahler/vibosuccess" target="_blank" rel="noopener noreferrer">{<FormattedMessage id="support.scheduleMeeting" />}</a>
             </div>
         </Dialog>
      )
   }
}

export default SupportDialog;



// WEBPACK FOOTER //
// ./src/components/supportDialog.component.js